{
  "payments": "Pagos",
  "settlement": "Liquidación",
  "wire-tranfers": "Transferencias Bancarias",
  "payee": "Beneficiario",
  "account": "Cuenta",
  "status": "Estado",
  "amount": "Cantidad",
  "origination_charges": "A. Cargos De Originación",
  "did_not_shop_for": "B. No Compré Para",
  "did_shop_for": "C. Hizo Compras Para",
  "taxes_and_fees": "E. Timpuestos y Honorarios",
  "prepaids": "F. Prepagos",
  "escrow": "G. Fideicomisos",
  "other_charges": "H. Otros Cargos",
  "no-charges": "Aún no se han creado cargos",
  "no-charges-leyend": "Por favor, vaya a la sección de cargos para agregar más información.",
  "authorization": "Es necesario autorizar la transferencia",
  "authorize": "Autorizar",
  "required": "Requerido",
  "reference": "Referencia",
  "authorize-wire-transfer-option": "Por favor, seleccione una opción para autorizar o rechazar la siguiente transferencia:",
  "reject": "Rechazar",
  "authorize-transfer": "Autorizar transferencia",
  "create-wire-tranfer": "Crear transferencia bancaria",
  "create-wire-transfer-advice": "Cuando se crea una transferencia, la solicitud se enviará a los usuarios correspondientes para su autorización.",
  "create-wire-transfer": "Crear transferencia bancaria",
  "instructions": "Instructions",
  "kind": "Tipo",
  "description": "Descripción",
  "party": "Partida",
  "file": "Archivo",
  "authorizations": "Autorizaciones",
  "disbursements-and-receipts": "Desembolsos",
  "started-at": "Comenzó en",
  "audit": "Auditoría",
  "transfers": "Transferencias",
  "total": "Total",
  "accounts": "Cuentas",
  "disbursements": "Desembolsos",
  "no-options": "Sin Opciones"
}
